<template>
  <div class="page_bg">
    <!-- 顶部返回 -->
    <div :class="types == 2 ?'list_bg02 flex-r-s-s':'list_bg01 flex-r-s-s'"
         style="padding: 0.32rem;font-size: 0.48rem;padding-top:0.4rem"
    >
      <van-icon name="arrow-left" @click="backPath" />
    </div>
    <!-- list -->
    <div class="order_list_box" style="width: 9.47rem;margin-left: 0.27rem;border-radius: 0.27rem;margin-top:-2rem">
      <MyscrollList ref="myList01" :loading="listLoading" :line-type="1" :list="proList" @myload="proload">
        <template #default="slotProps">
          <proCard07 :id="'classfily' + slotProps.item.productId" :info="slotProps.item" />
        </template>
      </MyscrollList>
    </div>
  </div>
</template>

<script>
import './index.scss'
import MyscrollList from '@/components/MyscrollList'
import { apiWholesaleProduct_productRecommendList } from '@/api/pro'
import { orderPayStatus } from '@/utils/constants'
import proCard07 from '@/components/pro_card_07'
export default {
  name: 'ProBannerList',
  components: { MyscrollList, proCard07 },
  data() {
    return {
      types: null, // 1爆品 2特惠
      // 商品列表
      title: '',
      id: '',
      proSearch: { page: 1, limit: 10, tagId: '' },
      proList: [],
      listLoading: false,
      statusList: orderPayStatus.statusList
    }
  },
  beforeRouteEnter(to, from, next) {
    next(() => {
      window.sessionStorage.setItem('lasterRouter', from.path)
    })
  },
  created() {
    this.types = this.$route.query.type
    // this.proSearch.limit = 1
    // this.getProList()
    console.log('ProBannerList created', this.types)
  },
  activated() {
    this.types = this.$route.query.type
    this.proSearch.page = 1
    this.proList = []
    this.getProList()
    console.log('ProBannerList 进入', this.types)
    // var id = sessionStorage.getItem('classify_pro_id')
    // document.getElementById(id).scrollIntoView()
  },
  deactivated() {
    this.types = null
    console.log('ProBannerList 离开', this.types)
  },
  methods: {
    backPath() { window.history.back() },
    getProList() {
      if (parseInt(this.types) === 1) { this.proSearch.tagId = '330' }
      if (parseInt(this.types) === 2) { this.proSearch.tagId = '331' }
      this.$toast.loading({ message: '加载中...', forbidClick: true, loadingType: 'spinner', duration: 0 })
      apiWholesaleProduct_productRecommendList(this.proSearch).then(res => {
        this.$toast.clear()
        this.$refs.myList01.load_loading(false)
        this.proList = this.proList.concat(res.data.list)
        if (parseInt(res.data.total) === 0) { this.$refs.myList01.load_empty('list', true) } else {
          if (res.data.list.length === 0) { this.$refs.myList01.load_finished(true) } // 数据全部加载完成
        }
      })
    },
    proload() {
      this.$refs.myList01.load_loading(true)
      this.$utils.debounce(() => {
        this.proSearch.page = this.proSearch.page + 1
        this.getProList()
        // 加载状态结束
      }, 50)()
    }
  }
}
</script>

<style>
.list_bg01 {
  color: #ffffff;
  font-size: 0.48rem;
  height: 5.07rem;
  background: url("https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale2/index/home_list_bg01.png");
  background-size: 10rem 5.07rem;
  background-repeat: no-repeat;
}
.list_bg02 {
  color: #ffffff;
  height: 5.07rem;
  font-size: 0.48rem;
  background: url("https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale2/index/home_list_bg02.png");
  background-size: 10rem 5.07rem;
  background-repeat: no-repeat;
}
</style>
